import React from 'react'
import { TreasuryResponse } from '../../../../types/gameApi/treasury'
import { DecisionMap } from '../TreasuryContainer'
import { calculateAssetsAndForecasts } from '../calculations'
import TreasuryBalanceSheetChart from './TreasuryBalanceSheetChart'
import TreasuryBalanceSheetDecisions from './TreasuryBalanceSheetDecisions'
import VerticalGroup from '../../../atoms/VerticalGroup/VerticalGroup'

interface Props {
  data: TreasuryResponse
  decisions: DecisionMap
  enableChanges: boolean
  onChangeValue: (val: Partial<DecisionMap>) => void
}

const TreasuryBalanceSheet: React.FC<Props> = ({
  data,
  decisions,
  enableChanges,
  onChangeValue,
}) => {
  const {
    allOtherAssetsForecast,
    cashForecastWithAutoWSF,
    wholesaleFundingForecast,
    depositsForecast,
    shareholdersFundsForecast,
    forecastEirAssetPercentage,
    forecastEirAssetPercentageChange,
    forecastEirMargin,
    marginChange,
    forecastEirCostPercentage,
    forecastEirCostPercentageChange,
    targetShareCapitalMovement,
  } = calculateAssetsAndForecasts({ data, decisions })

  return (
    <VerticalGroup full fullWidth gap={3} className="gap-4 laptop:flex-row">
      <div className="laptop:w-1/2">
        <TreasuryBalanceSheetChart
          allOtherAssetsForecast={allOtherAssetsForecast}
          cashForecastWithAutoWSF={cashForecastWithAutoWSF}
          wholesaleFundingForecast={wholesaleFundingForecast}
          depositsForecast={depositsForecast}
          shareholdersFundsForecast={shareholdersFundsForecast}
          forecastEirAssetPercentage={forecastEirAssetPercentage}
          forecastEirAssetPercentageChange={forecastEirAssetPercentageChange}
          forecastEirMargin={forecastEirMargin}
          marginChange={marginChange}
          forecastEirCostPercentage={forecastEirCostPercentage}
          forecastEirCostPercentageChange={forecastEirCostPercentageChange}
        />
      </div>
      <div className="laptop:w-1/2 ">
        <TreasuryBalanceSheetDecisions
          enableChanges={enableChanges}
          decisions={decisions}
          data={data}
          targetShareCapitalMovement={targetShareCapitalMovement}
          onChangeValue={onChangeValue}
        />
      </div>
    </VerticalGroup>
  )
}

export default TreasuryBalanceSheet
